@if (
  verificationForm &&
  ((!isOwner && !verificationProperty) || (isReadonly && !verificationPropertyValid))
) {
  <ax-proposal-verification-form
    class="section-wrapper"
    [form]="verificationForm"
    [possibleProperties]="possibleProperties"
    [verificationType]="proposal?.verification"
  ></ax-proposal-verification-form>
}
